import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { coreReadinessFactsChangedSchema } from "../protocol/core-readiness-facts-changed.js";
import { signalReplyToSchema } from "../protocol/signal-reply-to.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/signal-status.ts
const spaceStatusSchema = z$1.enum([
	"working",
	"needs_input",
	"done",
	"blocked",
	"handoff"
]);
const signalStatusGeneratedBySchema = z$1.literal("openmeld");
const signalStatusDataSchema = z$1.strictObject({
	actorProfileId: openMeldRuntimeProfileIdSchema,
	status: spaceStatusSchema,
	dispatchId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	resultRef: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	coreReadinessFactsChanged: coreReadinessFactsChangedSchema.optional(),
	replyTo: signalReplyToSchema.optional(),
	targetProfileId: openMeldRuntimeProfileIdSchema.optional(),
	text: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(120)),
	generatedBy: signalStatusGeneratedBySchema
});
z$1.strictObject({
	type: z$1.literal("signal.status"),
	data: signalStatusDataSchema
});
//#endregion
export { signalStatusDataSchema, signalStatusGeneratedBySchema, spaceStatusSchema };

//# sourceMappingURL=signal-status.js.map